import {
  DetailsView,
  FileManagerComponent,
  Inject,
  NavigationPane,
  Toolbar,
  ToolbarItemsDirective,
  ToolbarItemDirective,
} from "@syncfusion/ej2-react-filemanager";
import { DropDownButtonComponent } from "@syncfusion/ej2-react-splitbuttons";
import { Button } from "@material-ui/core";

import "@syncfusion/ej2-base/styles/material.css";
import "@syncfusion/ej2-icons/styles/material.css";
import "@syncfusion/ej2-inputs/styles/material.css";
import "@syncfusion/ej2-popups/styles/material.css";
import "@syncfusion/ej2-buttons/styles/material.css";
import "@syncfusion/ej2-splitbuttons/styles/material.css";
import "@syncfusion/ej2-navigations/styles/material.css";
import "@syncfusion/ej2-layouts/styles/material.css";
import "@syncfusion/ej2-grids/styles/material.css";
import "@syncfusion/ej2-react-filemanager/styles/material.css";
import { useRef, useState } from "react";
import { SERVER_URL } from "../../../api";
import { updateDeal } from "../../../api/deal";
import { alertError, alertSuccess } from "../../../utils/logger";
import { MAX_FILE_UPLOAD_BYTES } from "../../../constants/uploadLimits";

export default function DataroomTab({ id, path, deal, onDealUpdate }) {
  const [isDirectoryUpload, setIsDirectoryUpload] = useState(false);
  const fileRef = useRef(null);
  const [isUpdating, setIsUpdating] = useState(false);

  const items = [{ text: "Upload folder" }, { text: "Upload file" }];

  // Función para verificar si el botón debe mostrarse
  const shouldShowButton = () => {
    if (!deal?.currentStep) return false;
    // Mostrar solo si currentStep es "nda" (antes de llegar a "nbo")
    return deal.currentStep.toLowerCase() === "nda";
  };

  // Función para actualizar el deal a dataroomVisible
  const handleToggleDataroomVisibility = async () => {
    if (!deal?._id) return;

    setIsUpdating(true);
    try {
      const updatedDataroomVisible = !deal?.dataroomVisible;

      const updatedDeal = {
        ...deal,
        dataroomVisible: updatedDataroomVisible,
        projectId: deal?.project?._id || deal?.project,
        buyerId: deal?.buyer?._id || deal?.buyer,
      };

      // Eliminar campos que no deben enviarse
      delete updatedDeal.project;
      delete updatedDeal.buyer;
      delete updatedDeal.__v;
      delete updatedDeal.createdAt;
      delete updatedDeal.updatedAt;

      const response = await updateDeal(deal._id, updatedDeal);

      alertSuccess({
        customMessage: `Dataroom ${
          updatedDataroomVisible ? "habilitado" : "deshabilitado"
        } en la web.`,
      });

      // Notificar al componente padre para actualizar el deal
      if (onDealUpdate && response?.data) {
        onDealUpdate(response.data);
      }
    } catch (error) {
      alertError({
        error,
        customMessage: "Error al actualizar la visibilidad del dataroom.",
      });
    } finally {
      setIsUpdating(false);
    }
  };

  const onSelect = (args) => {
    setIsDirectoryUpload(args.item.text === "Upload folder");

    setTimeout(() => {
      const uploadBtn = document.querySelector(".e-file-select-wrap button");
      uploadBtn.click();
    }, 100);
  };

  const uploadClick = (e) => {
    e.stopPropagation();
  };

  const uploadTemplate = () => (
    <DropDownButtonComponent
      id="dropButton"
      cssClass="e-tbar-btn e-tbtn-txt"
      onClick={uploadClick}
      items={items}
      iconCss="e-icons e-fe-upload"
      select={onSelect}
    >
      <span className="e-tbar-btn-text">Upload</span>
    </DropDownButtonComponent>
  );

  return (
    <>
      {shouldShowButton() && (
        <div
          style={{
            marginBottom: "16px",
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            gap: "12px",
          }}
        >
          <Button
            variant="contained"
            color={deal?.dataroomVisible ? "secondary" : "primary"}
            onClick={handleToggleDataroomVisibility}
            disabled={isUpdating}
            style={{ marginBottom: "16px" }}
          >
            {isUpdating
              ? "Actualizando..."
              : deal?.dataroomVisible
              ? "Deshabilitar Dataroom en Web"
              : "Habilitar Dataroom en Web"}
          </Button>
        </div>
      )}
      <FileManagerComponent
        ref={fileRef}
        height="70vh"
        allowMultiSelection={true} /// !!!!!!
        rootAliasName={`Deal Data Room`}
        ajaxSettings={{
          url: `${SERVER_URL}/api/filemanager/FileOperations/${id}?folder=${path}`,
          downloadUrl: `${SERVER_URL}/api/filemanager/Download?idFolder=${id}&folder=${path}`,
          uploadUrl: `${SERVER_URL}/api/filemanager/Upload/${id}?folder=${path}`,
          getImageUrl: `${SERVER_URL}/api/filemanager/GetImage/${id}?folder=${path}`,
        }}
        // toolbarSettings={toolbarSettings}
        uploadSettings={{
          autoClose: true,
          directoryUpload: isDirectoryUpload,
          minFileSize: 0,
          maxFileSize: MAX_FILE_UPLOAD_BYTES,
        }}
        allowDragAndDrop={true}
      >
        <ToolbarItemsDirective>
          <ToolbarItemDirective name="NewFolder" />
          <ToolbarItemDirective template={uploadTemplate} name="Upload" />
          {/*<ToolbarItemDirective name="SortBy" />
          <ToolbarItemDirective name="Refresh" />*/}
          <ToolbarItemDirective name="Cut" />
          <ToolbarItemDirective name="Copy" />
          <ToolbarItemDirective name="Paste" />
          <ToolbarItemDirective name="Delete" />
          <ToolbarItemDirective name="Download" />
          <ToolbarItemDirective name="Rename" />
          {/*<ToolbarItemDirective name="Selection" />*/}
          <ToolbarItemDirective name="View" />
          <ToolbarItemDirective name="Details" />
        </ToolbarItemsDirective>
        <Inject services={[NavigationPane, DetailsView, Toolbar]} />
      </FileManagerComponent>
    </>
  );
}
